<template>
  <div>
    <div class="mb-3 text-sm alert alert-warning">Мэргэшсэн нягтлан бодогч гишүүн та Мэргэжлийн хөгжлийн үйл ажиллагаатай холбоотой дараах ажлуудад оролцсон цагаа тооцож оруулна уу. Бид гишүүдээс санамсаргүй байдлаар сонголт хийж тус цагийг баталгаажуулах тул нотлох баримтыг өөртөө хадгалж байхыг анхаарна уу.</div>
    <table class="table table-bordered table-striped">
        <thead>
            <tr>
                <th>№</th>
                <th>Мэргэжлийн хөгжлийн үйл ажиллагаа</th>
                <th>Оролцсон цаг</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(task, index) in answers" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ task.task }}</td>
                <td class="p-0">
                    <!-- :disabled="isintime()" -->
                <input-number :disabled="taskModel.planTypeId === 1" v-model="taskModel[task.prefix]"
                
                 :min="0" :max="taskModel.i1" class="custom-input-number" />
                <!-- {{ taskModel[task.prefix] }} {{ task.prefix }} {{ taskModel.id }} -->
                </td>
            </tr>
            <tr>
                <td colspan="2">Нийт оролцсон цаг</td>
                <td class="text-center">{{ reduceSum() }}/{{ reduceSum2() }}</td>
            </tr>
        </tbody>
    </table>

    <!-- v-if="!isintime()" -->
    <div class="flex items-center" v-show="taskModel.planTypeId !== 1">
        <div class="alert alert-info">
          Нийт оролцсон цаг {{ reduceSum2() }} оноог хангаснаар илгээх боломжтой
        </div>
        <a @click="save" class="btn btn-primary ml-auto">Илгээх</a>
    </div>

    <!-- {{ taskModel.id}} -->

    <!-- <div v-else class="flex justify-between items-center mt-3">
        ilgeetsen bnaa
    </div> -->
  </div>
</template>
<script>
import { request } from "@/api/all";
import { getConfigValueByKey } from "@/libs/util";

import "element-ui/lib/theme-chalk/index.css";
import { InputNumber, Notification } from "element-ui";

import _ from "lodash";
import moment from "moment";

export default {
  name: 'memberMonicpaMHVA',
  components: {
    InputNumber,
  },
  data() {
    return {
      box: null,
      task: null,
      taskModel: {
        id: 0,
      },
      answers: [],
      servernow: null,
    };
  },
  mounted() {
    this.toggleBodyClass("addClass", "app-lms");
    require("@/assets/css/dynamic.lms.css");
    this.init();
  },
  beforeDestroy() {
    this.toggleBodyClass("removeClass", "app-lms");
  },
  methods: {
    isintime() {
        if(this.taskModel.id === 0) {
            return false;
        }
        // console.log(this.servernow, this.servernow.isAfter(this.taskModel.d1));
      return moment(this.servernow).isAfter(this.taskModel.d1);
      //&& moment(this.servernow).isBefore(this.taskModel.d2);
    },
    toggleBodyClass(action, className) {
      if (action === "addClass") {
        document.body.classList.add(className);
      } else if (action === "removeClass") {
        document.body.classList.remove(className);
      }
    },
    init() {
        request({
        api: { method: "GET", url: "task/taskInheritedDetail" },
        params: {
          id: this.$store.state.user.userInfo.profileId,
        },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          let b = res.data.task.b.filter((x) => x.ot == 636);
          if (b != undefined) {
            request({
              api: { method: "GET", url: "task/boxInTaskList" },
              params: { id: b[0].id },
              store: this.$store,
            }).then((res) => {
              if (res != false) {
                // console.log(res);
                this.box = res.data.box;

                // console.log('step 1');

                if (res.data.tasks.length) {
                    this.taskModel = res.data.tasks[0];
                }

                request({
                    api: { method: "GET", url: "Task/GetInherited" },
                    params: {
                        id: this.taskModel.id,
                        projectId: this.box.projectId,
                        parentId: this.box.taskId,
                        boxId: this.box.id,
                        objectTypeId: this.box.objectTypeId,
                        userId: this.box.parentTaskUserId,
                    },
                    store: this.$store,
                }).then((res) => {
                    if (res != false) {
                        // console.log(res);
                        this.taskModel = res.data.task;
                        this.taskModel.task = "Мэргэжлийн хөгжлийн үйл ажиллагаа";

                        this.taskModel.i1 = parseInt(getConfigValueByKey(this.$store.state.app.groupSettings, "memberPointMHVA"), 10);
                        
                        request({
                            api: { method: "GET", url: "servertime" },
                            store: this.$store
                        }).then(res => {
                            if (res != false) {
                                if(this.taskModel.id === 0) {
                                    this.taskModel.d1 = res.data.now;
                                    this.taskModel.d2 = moment(this.taskModel.d1).endOf('year').utc().toDate();
                                }else{
                                    this.taskModel.d1 = res.data.now;
                                    this.taskModel.d2 = moment(this.taskModel.d1).endOf('year').utc().toDate();
                                    this.servernow = res.data.now;
                                }
                            }
                        });

                        this.initAnswer();
                    }
                });
              }
            });
          }
        }
      });
    },
    initAnswer() {
    //   console.log('initAnswer');

      request({
        api: { method: "POST", url: "TaskCore/GetCoreList" },
        data: {
          ot: 637,
          skip: 0,
          size: 100,
          model: { isPublic: true }
        },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
        //   console.log(res);
          this.answers = _.sortBy(res.data.tasks, 'ord');
        }
      });
    },
    reduceSum() {
      let sum = 0;
      let self = this;
      this.answers.forEach(answer => {
        sum += self.taskModel[answer.prefix];
      });
      return sum;
    },
    reduceSum2() {
      let sum = 0;
      this.answers.forEach(answer => {
        sum += answer.i1;
      });
      return sum;
    },
    save() {
      console.log(this.taskModel.i1, this.reduceSum());
      if(this.taskModel.i1 !== this.reduceSum()) {
        Notification.error({
            title: 'Анхаарна уу',
            message: `Та ${moment(this.taskModel.d1).format('YYYY онд')} мэргэжлийн хөгжлийн үйл ажиллагааны ${this.reduceSum2()} оноог хангасан байхыг анхаарна уу.`,
        });
        return;
      }

      this.taskModel.planTypeId = 1;

      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "Task/PostInherited" },
        data: { model: this.taskModel },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
            this.$emit('on-refresh');
          Notification.success({
            title: 'Амжилттай',
            message: 'Амжилттай илгээгдлээ.',
          });
        }
      });
    }
  },
};
</script>

<style lang="scss">
.custom-input-number {
  width: auto;
  .el-input{
    width: auto;
    .el-input__inner{
        padding-left: 0;
        padding-right: 0;
        width: 130px;
    }
  }
}
</style>
